import React, { useEffect, useMemo, useState } from "react";
import { getSettings } from "../../../services/settingsServices";
import { toAbsolutePhotoUrl } from "../../../services/settingsPhotoServices";

const FALLBACK_LOGO = "/img/logo_club.png";

const LogoSection = () => {
  const [settings, setSettings] = useState({
    nom_club: "",
    shortname_club: "",
    logo_club: "",
  });

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const data = await getSettings();
        if (Array.isArray(data) && data.length > 0) setSettings(data[0]);
      } catch (e) {
        console.error("LogoSection > getSettings error:", e);
      }
    };
    fetchSettings();
  }, []);

  // ✅ URL absolue si /uploads/..., sinon inchangé (Cloudinary ok)
  const logoSrc = useMemo(() => {
    const raw = (settings.logo_club || "").trim();
    return toAbsolutePhotoUrl(raw) || FALLBACK_LOGO;
  }, [settings.logo_club]);

  // ✅ nom “court” sur mobile (simple)
  const clubName =
    typeof window !== "undefined" && window.innerWidth < 400
      ? settings.shortname_club
      : settings.nom_club;

  return (
    <div className="flex items-center">
      <img
        className="h-8 sm:h-12 lg:h-16"
        src={logoSrc}
        alt="Logo du club"
        loading="lazy"
        onError={(e) => {
          e.currentTarget.src = FALLBACK_LOGO;
        }}
      />

      <div className="ml-2 text-sm sm:text-xl lg:text-2xl font-bold text-gray-800 uppercase">
        {clubName || "Association"}
      </div>
    </div>
  );
};

export default LogoSection;
